export default __webpack_public_path__ + "d162f806f8f6151713537f2978b37ba5.webp";